export function isSmartiLabEnabled() {
  const configured = String(process.env.REACT_APP_SMARTI_LAB_ENABLED || '').trim().toLowerCase();
  if (configured === 'false') return false;
  return true;
}
